import React from "react";
import IconRenderer from "../../components/common/IconRenderer";
import {
	useBlockStyle,
	useClientId,
	useCopyPasteStyles,
	useDeviceType,
} from "../../hooks";
import { EditProps } from "../../types";
import { cn } from "../../utils";
import InspectorControls from "./components/InspectorControls";
import "./style.scss";

const Edit: React.ComponentType<EditProps<any>> = (props) => {
	const {
		attributes: { icon, presets, contentHorizontalAlign, cssID, className },
	} = props;
	const { clientId } = useClientId(props);
	const { deviceType } = useDeviceType();
	const { CopyPasterStyleBlockControl } = useCopyPasteStyles();
	const { Style } = useBlockStyle({
		blockName: "icon",
		clientId,
		attributes: props.attributes,
		deviceType,
	});

	return (
		<>
			<InspectorControls
				attributes={props.attributes}
				setAttributes={props.setAttributes}
			/>
			<CopyPasterStyleBlockControl withBlockControls />
			<Style />
			<div
				id={cssID ? cssID : null}
				className={cn(
					`mzb-icon-block mzb-icon-${clientId}`,
					contentHorizontalAlign && `mzb-${contentHorizontalAlign}`,
					className
				)}
			>
				<div className="mzb-outside-icon mzb-icon-link">
					<span
						className={cn(
							`mzb-icon-wrapper`,
							presets && `mzb-${presets}`,
							className
						)}
					>
						<IconRenderer name={icon} />
					</span>
				</div>
			</div>
		</>
	);
};

export default Edit;
